import { createAsyncThunk } from "@reduxjs/toolkit";
import { CoreServices } from "../../base/service/apiServices";

export const getDidNumber = createAsyncThunk(
  "users/didPurchaseList",
  async () => {
    return CoreServices.get(`/did_purchase_list`)
      .then((response) => {
        return response;
      })
      .catch((error) => error);
  }
);
export const getQueueList = createAsyncThunk("users/getQueueList", async () => {
  return CoreServices.get(`/get_queue_list`)
    .then((response) => {
      return response;
    })
    .catch((error) => error);
});

export const getDidPurchaseList = createAsyncThunk(
  "users/getDidPurchaseList",
  async () => {
    return CoreServices.get(`/get_did_purchases`)
      .then((response) => {
        return response;
      })
      .catch((error) => error);
  }
);

export const getDidPurchase = createAsyncThunk(
  "users/getDidPurchase",
  async (pid: any) => {
    return CoreServices.get(`/get_did_purchase/${pid}`)
      .then((response) => {
        return response;
      })
      .catch((error) => error);
  }
);

export const updateDetails = createAsyncThunk(
  "users/updateDetails",
  async (data: any) => {
    return CoreServices.post(data, `/update_didnumber_sms/${data.pid}`)
      .then((response) => {
        return response;
      })
      .catch((error) => error);
  }
);

export const isSmsUpdate = createAsyncThunk(
  "users/updateIsSms",
  async (data: any) => {
    return CoreServices.post(data, `/update_is_sms/${data.pid}`)
      .then((response) => {
        return response;
      })
      .catch((error) => error);
  }
);

export const getSupervisorList = createAsyncThunk("users/get_supervisor_list", async () => {
  return CoreServices.get(`/get_supervisor_list`)
    .then((response) => {
      return response;
    })
    .catch((error) => error);
});
